import React, { useState, useEffect } from "react";
// import "../../Styles/Filter.css";
import { FaFilter, FaAngleUp, FaAngleDown, FaTimes } from "react-icons/fa";

function EventFilter({ setProductData, productData }) {
  const [selectedEventType, setSelectedEventType] = useState("Events");
  const [selectedColors, setSelectedColors] = useState([]);
  const [showEventTypeDropdown, setShowEventTypeDropdown] = useState(true);
  const [showSortDropdown, setShowSortDropdown] = useState(true);
  const [showColorDropdown, setShowColorDropdown] = useState(true);
  const [selectedOption, setSelectedOption] = useState("");
  const [allProducts, setAllProducts] = useState([]);
  const [availableColors, setAvailableColors] = useState([]);
  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);

  const toggleMobileFilter = () => {
    setIsMobileFilterOpen(!isMobileFilterOpen);
  };

  useEffect(() => {
    if (isMobileFilterOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMobileFilterOpen]);

  // Extract unique colors from all products
  const extractColorsFromProducts = (products) => {
    const colorMap = new Map();
    
    products.forEach(product => {
      if (product.color && Array.isArray(product.color)) {
        product.color.forEach(color => {
          if (color.color_id && color.name && color.code) {
            colorMap.set(color.color_id, {
              id: color.color_id,
              name: color.name,
              code: color.code
            });
          }
        });
      }
    });

    return Array.from(colorMap.values());
  };

  // Update available colors when products change
  useEffect(() => {
    if (productData && productData.length > 0) {
      setAllProducts(productData);
      const colors = extractColorsFromProducts(productData);
      setAvailableColors(colors);
    }
  }, [productData]);

  const handleColorSelection = (colorId) => {
    setSelectedColors(prev => {
      if (prev.includes(colorId)) {
        return prev.filter(id => id !== colorId);
      } else {
        return [...prev, colorId];
      }
    });
  };

  const applyFilter = () => {
    let filteredProducts = [...allProducts];
    
    // Apply sorting
    if (selectedOption === "NewestFirst") {
      filteredProducts.sort((a, b) => b.id - a.id);
    } else if (selectedOption === "OldFirst") {
      filteredProducts.sort((a, b) => a.id - b.id);
    } else if (selectedOption === "lowToHigh") {
      filteredProducts.sort((a, b) => (a.price || 0) - (b.price || 0));
    } else if (selectedOption === "highToLow") {
      filteredProducts.sort((a, b) => (b.price || 0) - (a.price || 0));
    }
    
    // Apply event type filtering
    if (selectedEventType !== "All Events") {
      filteredProducts = filteredProducts.filter(product => 
        product.event_type === selectedEventType
      );
    }
    
    // Apply color filtering
    if (selectedColors.length > 0) {
      filteredProducts = filteredProducts.filter(product => {
        if (!product.color || !Array.isArray(product.color)) return false;
        return product.color.some(color => 
          selectedColors.includes(color.color_id)
        );
      });
    }
    
    setProductData(filteredProducts);
  };

  const clearAllFilters = () => {
    setSelectedEventType("All Events");
    setSelectedColors([]);
    setSelectedOption("");
    setProductData(allProducts);
  };

  const handleToggleDropdown = () => {
    setShowSortDropdown((prev) => !prev);
  };

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
    setShowSortDropdown(false);
  };

  // Sample event types - replace with your actual event types
  const eventTypes = ["Events"];

  return (
    <>
      
      <div className="filter-section">
        <div className="filter-container">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3 className="filter-title large1" style={{ fontSize: "20px", margin: 0 }}>
              Filters
            </h3>
          </div>

          <div className="dropdown-section">
            <h4 className="section-title" style={{ fontSize: "16px" }}>
              SORT BY
            </h4>
            <div className="dropdown-wrapper" onClick={handleToggleDropdown}>
              <select
                id="dropdown"
                value={selectedOption}
                onChange={handleSelectChange}
                className="custom-select"
              >
                <option value="" style={{ fontSize: "14px" }}>
                  ---Select---
                </option>
                <option value="NewestFirst" style={{ fontSize: "14px" }}>
                  Newest First
                </option>
                <option value="OldFirst" style={{ fontSize: "14px" }}>
                  Oldest First
                </option>
                <option value="lowToHigh" style={{ fontSize: "14px" }}>
                  Price: Low to High
                </option>
                <option value="highToLow" style={{ fontSize: "14px" }}>
                  Price: High to Low
                </option>
              </select>
              <span className="dropdown-icon">
                {showSortDropdown ? <FaAngleUp /> : <FaAngleDown />}
              </span>
            </div>
          </div>

          {/* EVENT TYPE */}
          <div className="category-section">
            <div
              className="dropdown-header"
              onClick={() => setShowEventTypeDropdown(!showEventTypeDropdown)}
            >
              <h4 className="section-title" style={{ fontSize: "16px" }}>
                Event Type
              </h4>
              {showEventTypeDropdown ? <FaAngleUp /> : <FaAngleDown />}
            </div>
            {showEventTypeDropdown && (
              <div className="category-boxes">
                {eventTypes.map((type, index) => (
                  <button
                    key={index}
                    className={`category-box ${selectedEventType === type ? "selected" : ""}`}
                    onClick={() => {
                      setSelectedEventType(type);
                    }}
                    style={{ fontSize: "14px" }}
                  >
                    {type}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* COLOR SECTION */}
          <div className="color-section">
            <div
              className="dropdown-header"
              onClick={() => setShowColorDropdown(!showColorDropdown)}
            >
              <h4 className="section-title" style={{ fontSize: "16px" }}>
                COLOR
              </h4>
              {showColorDropdown ? <FaAngleUp /> : <FaAngleDown />}
            </div>
            {showColorDropdown && (
              <div className="color-grid-container">
                {availableColors.map((color) => (
                  <div
                    key={color.id}
                    className={`color-option ${selectedColors.includes(color.id) ? "selected" : ""}`}
                    onClick={() => handleColorSelection(color.id)}
                    title={color.name}
                  >
                    <div className="color-swatch-container">
                      <div
                        className="color-swatch"
                        style={{ backgroundColor: color.code }}
                      />
                      <div className="color-checkmark">
                        {selectedColors.includes(color.id) && (
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path d="M20 6L9 17l-5-5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        )}
                      </div>
                    </div>
                    <span className="color-name">{color.name}</span>
                  </div>
                ))}
                {availableColors.length === 0 && (
                  <p className="no-colors-message">No colors available</p>
                )}
              </div>
            )}
          </div>

          <button
            className="filter-button"
            onClick={applyFilter}
            style={{ fontSize: "20px",    marginTop: "23px" }}
          >
            Apply Filters
          </button>
        </div>
      </div>

      {/* Mobile Filter Panel (similar structure with mobile-specific classes) */}
      <div
        className={`mobile-filter-overlay ${isMobileFilterOpen ? "open" : ""}`}
        onClick={toggleMobileFilter}
      ></div>

      <div
        className={`mobile-filter-panel ${isMobileFilterOpen ? "open" : ""}`}
      >
        

        <div className="mobile-filter-content" style={{ marginTop: "13px" }}>
          {/* Mobile versions of the same filter sections */}
          {/* ... */}
        </div>
      </div>
        <style jsx>{`
  /* Modern Color Filter Styles */
  .color-grid-container {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    margin-top: 12px;
  }

  .color-option {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .color-option:hover {
    transform: translateY(-2px);
  }

  .color-swatch-container {
    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-bottom: 6px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    transition: all 0.2s ease;
  }

  .color-swatch {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 2px solid white;
    box-sizing: border-box;
  }

  .color-checkmark {
    position: absolute;
    top: -4px;
    right: -4px;
    width: 18px;
    height: 18px;
    background-color: #2c3e50;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transform: scale(0.8);
    transition: all 0.2s ease;
  }

  .color-checkmark svg {
    width: 10px;
    height: 10px;
    color: white;
  }

  .color-option.selected .color-checkmark {
    opacity: 1;
    transform: scale(1);
  }

  .color-option.selected .color-swatch-container {
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
  }

  .color-name {
    font-size: 12px;
    color: #333;
    text-align: center;
    max-width: 60px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Mobile Color Grid */
  .mobile-color-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    margin-top: 10px;
  }

  .mobile-color-option {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px;
    border-radius: 8px;
    background-color: #f8f8f8;
  }

  .mobile-color-option.selected {
    background-color: #e8f0fe;
    border: 1px solid #2c3e50;
  }

  .mobile-color-swatch-container {
    position: relative;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin-bottom: 4px;
  }

  .mobile-color-swatch {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 2px solid white;
  }

  .mobile-color-checkmark {
    position: absolute;
    top: -4px;
    right: -4px;
    width: 16px;
    height: 16px;
    background-color: #2c3e50;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mobile-color-checkmark svg {
    width: 8px;
    height: 8px;
    color: white;
  }

  .mobile-color-name {
    font-size: 11px;
    color: #333;
    text-align: center;
  }

  .no-colors-message {
    grid-column: 1 / -1;
    text-align: center;
    font-size: 14px;
    color: #666;
    font-style: italic;
    padding: 10px 0;
  }
`}</style>
    </>
  );
}

export default EventFilter;